/** DataBest — Scoring + Caregiver + Dictionaries API. */
import api from "@/lib/axios";

export const scoringApi = {
    todayTasks: (individual_id) =>
        api.get("/caregiver/today-tasks", {
            params: individual_id ? { individual_id } : {},
        }).then((r) => r.data),
    list: (params) => api.get("/measurements", { params }).then((r) => r.data),
    create: (data) => api.post("/measurements", data).then((r) => r.data),
    update: (id, data) => api.patch(`/measurements/${id}`, data).then((r) => r.data),
    validateText: (text) =>
        api.post("/measurements/validate", { text }).then((r) => r.data),
    uploadVoice: (measurementId, blob, mime) => {
        const fd = new FormData();
        fd.append("file", blob, `voice.${mime.includes("wav") ? "wav" : "webm"}`);
        return api
            .post(`/measurements/${measurementId}/voice`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((r) => r.data);
    },
};

export const dictionariesApi = {
    scoring: () => api.get("/dictionaries/scoring").then((r) => r.data),
    listWords: (params) =>
        api.get("/dictionaries/prohibited-words", { params }).then((r) => r.data),
    createWord: (data) =>
        api.post("/dictionaries/prohibited-words", data).then((r) => r.data),
    updateWord: (id, data) =>
        api.patch(`/dictionaries/prohibited-words/${id}`, data).then((r) => r.data),
    deleteWord: (id) =>
        api.delete(`/dictionaries/prohibited-words/${id}`).then((r) => r.data),
};
